$mol_labeler $mol_list
	rows /
		<= Label $mol_view
			minimal_height 32
			sub <= label /$mol_view_content
				<= title
		<= Content $mol_view
			minimal_height 24
			sub <= content /
